import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityHistory } from "../../entity/EntityHistory";

export class DtoHistorysGetReq extends EntityHistory {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_history_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
